
export function  logout () {
    localStorage.removeItem('token');
    window.location = `${process.env.PUBLIC_URL}/`;
}